module.exports = __webpack_public_path__ + "img/Waneluba-Isiah.fb4a4afd.jpg";